export default "public/Frame_31_32_33.svg";